import React from 'react'
import styled from 'styled-components'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import ExperienceCard from '../Cards/ExperienceCard';
import { experiences } from '../../data/constants';
import { motion } from 'framer-motion';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 40px 0px 80px 0px;
    @media (max-width: 960px) {
        padding: 0px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1500px;
    padding: 80px 0;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 24px;
    margin-bottom: 24px;

    @media (max-width: 1024px) {
        padding: 0 16px;
    }
`;

const TitleBlock = styled.div`
    flex-shrink: 0;
    white-space: nowrap;
    text-align: center;
`;

const Title = styled.h2`
    display: inline-block;
    font-size: 76px;
    text-align: left;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: -1.5px;
    line-height: 1;
    color: ${({ theme }) => theme.text_primary};
    margin: 0;

    @media (max-width: 1400px) {
        font-size: 64px;
    }

    @media (max-width: 1200px) {
        font-size: 52px;
    }

    @media (max-width: 768px) {
        font-size: 44px;
    }
`;

const TitleAccent = styled.span`
    display: inline-block;
    font-family: 'Mosca Laroke', 'Playfair Display', 'Bodoni Moda', 'Cinzel', serif;
    font-size: 76px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1;
    color: ${({ theme }) => theme.primary};
    letter-spacing: 0.5px;

    @media (max-width: 1400px) {
        font-size: 64px;
    }

    @media (max-width: 1200px) {
        font-size: 52px;
    }

    @media (max-width: 768px) {
        font-size: 44px;
        margin-left: 12px;
    }
`;

const TimelineSection = styled.div`
    width: 100%;
    max-width: 1500px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
`;

const index = () => {
    return (
        <Container id="experience">
            <Wrapper
                as={motion.div}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <HeaderRow>
                    <TitleBlock>
                        <Title>
                            <TitleAccent>EXPERIENCE</TitleAccent>
                        </Title>
                    </TitleBlock>
                </HeaderRow>
                <TimelineSection>
                    <Timeline>
                        {experiences.map((experience, index) => (
                            <TimelineItem key={experience.id}>
                                <TimelineSeparator>
                                    <TimelineDot variant="outlined" color="secondary" />
                                    {index !== experiences.length - 1 && <TimelineConnector style={{ background: '#854CE6' }} />}
                                </TimelineSeparator>
                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                    <ExperienceCard experience={experience} />
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>

                </TimelineSection>
            </Wrapper>
        </Container>
    )
}

export default index